import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Image from '../../base_image/component';
import Link from '../../base_link/component';
import './styles/styles.scss';

class BannerCover extends Component {
  constructor(props) {
    super(props);
    this.pushGoogleTags = this.pushGoogleTags.bind(this);
  }

  pushGoogleTags() {
    this.props.googleTagMethods()
      .pushPromotionGoogleTag(this.props);
  }

  bannerContent() {
    const { rightImage, buttonText } = this.props;
    return (
      <div className="container">
        <Image src={rightImage} alt="promo banner" className="banner-img"/>

        {!!buttonText && (
          <div className="buttonwrap">
            <button className="btn btn-primary">{buttonText}</button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { url, colorCode, backgroundImage, rightImage, buttonText } = this.props;
    const backgroundStyle = { backgroundColor: colorCode };

    if (!!url) {
      if (!!backgroundImage) {
        return (
          <Link
            href={url}
            style={backgroundStyle}
            className="banner-cover"
            onClick={this.pushGoogleTags}
          >
            <div className="img-container">
              <Image src={backgroundImage} alt="promo banner"/>
            </div>
            {this.bannerContent()}
          </Link>
        );
      }
      return (
        <div style={backgroundStyle} className="banner-cover">
          <div className="container">
            <Link
              href={url}
              onClick={this.pushGoogleTags}
            >
              <Image src={rightImage} alt="promo banner" className="banner-img"/>
              {!!buttonText && (
                <div className="buttonwrap">
                  <button className="btn btn-primary">{buttonText}</button>
                </div>
              )}
            </Link>

          </div>
        </div>
      );
    }
    return (
      <div style={backgroundStyle} className="banner-cover">
        <div className="img-container">
          <Image src={backgroundImage} alt="promo banner"/>
        </div>
        {this.bannerContent()}
      </div>
    );
  }
}
BannerCover.propTypes = {
  /**
   * Image placed in the background
   */
  backgroundImage: PropTypes.string,
  /**
   * Color code for the background
   */
  colorCode: PropTypes.string,
  /**
   * Right image of the banner
   */
  rightImage: PropTypes.string,
  /**
   * Text that is placed inside the button
   * if there is no text, there will be no button shown
   */
  buttonText: PropTypes.string,
  /**
   * An additional link that refers to another page
   */
  url: PropTypes.string,
  /**
   * Function that returns an object with
   * Google Tags methods
   */
  googleTagMethods: PropTypes.func,
};

export default BannerCover;
